import { Stack } from "@/components/layout/Stack";
export type { StackProps } from "@/components/layout/Stack";
export { Stack };
